// extracted by mini-css-extract-plugin
module.exports = {"error_message":"styles_error_message__3viLI"};